import React from 'react'

import InputContainer from './InputContainer.js'
import Checkbox from '../ncss/Checkbox.js'

export default ({ label, input, meta, ...props }) => (
  <InputContainer meta={meta} type='checkbox'>
    <Checkbox {...input} {...props} checked={input.checked || input.value} label={label} />
  </InputContainer>
)



// WEBPACK FOOTER //
// ./client/src/components/forms/Checkbox.js